import AccessView from './AccessView.vue'
export default AccessView
